import { PortableText } from '@portabletext/react'
import { ArbitraryTypedObject, PortableTextBlock } from '@portabletext/types'
import { useContext } from 'react'

import { recursiveUpdateValue } from '@lib/helpers'
import { LanguageContext } from '@lib/language'
import { getTextWithShippingDates } from '@lib/shipping'
import { SiteContext } from '@lib/site'

import ColoredText from './blocks/colored-text'
import Link from './blocks/link'

type SimplePortableTextBlock = PortableTextBlock | ArbitraryTypedObject

interface SimplePortableTextProps {
  content: SimplePortableTextBlock[]
  className?: string
}

const SimplePortableText = ({
  content,
  className,
}: SimplePortableTextProps) => {
  const { locale } = useContext(LanguageContext)
  const { cartSettings } = useContext(SiteContext)

  const contentWithVariables = recursiveUpdateValue(
    content,
    (value, currentKey) => {
      if (
        currentKey === 'text' &&
        value &&
        typeof value === 'string' &&
        value.includes('{') &&
        value.includes('}') &&
        cartSettings
      ) {
        return getTextWithShippingDates(locale, cartSettings, value)
      }

      return value
    },
  ) as SimplePortableTextBlock[]

  return (
    <div className={className}>
      <PortableText
        value={contentWithVariables}
        components={{
          block: {
            none: ({ children }) => <>{children}</>,
            normal: ({ children }) => <p>{children}</p>,
          },
          marks: {
            link: Link,
            textColor: ColoredText,
          },
        }}
      />
    </div>
  )
}

export default SimplePortableText
